import { useState } from 'react';
import {
  Box,
  Flex,
  Text,
  Icon,
  Collapse,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';

interface QuoteBannerProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

const QuoteBanner = ({
  title,
  children,
  defaultExpanded = true,
}: QuoteBannerProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const headerBg = useColorModeValue('blue.50', 'blue.900');

  return (
    <Box borderWidth="1px" borderRadius="lg" mb={4}>
      <Flex
        bg={headerBg}
        px={4}
        py={3}
        borderTopRadius="lg"
        borderBottomRadius={isExpanded ? 'none' : 'lg'}
        cursor="pointer"
        onClick={() => setIsExpanded(!isExpanded)}
        align="center"
        justify="space-between"
      >
        <Flex align="center" gap={2}>
          <Icon
            as={isExpanded ? ChevronDownIcon : ChevronRightIcon}
            boxSize={5}
          />
          <Text fontWeight="600">{title}</Text>
        </Flex>
      </Flex>
      <Collapse in={isExpanded}>
        <Box p={4}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default QuoteBanner;
